/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * userAndPermissionApi API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  PatchV6UsersLockParams,
  PostV6AccessMenuParams,
  User2FaRequest,
  UserAccessMenuRequest,
  UserLoginRequest,
  UserLoginV6Response,
  UserV6Response,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary accessMenu
 */
export const postV6AccessMenu = (
  userAccessMenuRequest: MaybeRef<UserAccessMenuRequest>,
  params?: MaybeRef<PostV6AccessMenuParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  userAccessMenuRequest = unref(userAccessMenuRequest);
  params = unref(params);

  return customAxiosInstance<string>(
    {
      url: `/api/v6/access-menu`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userAccessMenuRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV6AccessMenuMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6AccessMenu>>,
    TError,
    { data: BodyType<UserAccessMenuRequest>; params?: PostV6AccessMenuParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6AccessMenu>>,
  TError,
  { data: BodyType<UserAccessMenuRequest>; params?: PostV6AccessMenuParams },
  TContext
> => {
  const mutationKey = ['postV6AccessMenu'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6AccessMenu>>,
    { data: BodyType<UserAccessMenuRequest>; params?: PostV6AccessMenuParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV6AccessMenu(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6AccessMenuMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6AccessMenu>>
>;
export type PostV6AccessMenuMutationBody = BodyType<UserAccessMenuRequest>;
export type PostV6AccessMenuMutationError = ErrorType<unknown>;

/**
 * @summary accessMenu
 */
export const usePostV6AccessMenu = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6AccessMenu>>,
      TError,
      { data: BodyType<UserAccessMenuRequest>; params?: PostV6AccessMenuParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6AccessMenu>>,
  TError,
  { data: BodyType<UserAccessMenuRequest>; params?: PostV6AccessMenuParams },
  TContext
> => {
  const mutationOptions = getPostV6AccessMenuMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 로그인 v6
 */
export const postV6Login = (
  userLoginRequest: MaybeRef<UserLoginRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  userLoginRequest = unref(userLoginRequest);

  return customAxiosInstance<UserLoginV6Response>(
    {
      url: `/api/v6/login`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: userLoginRequest,
      signal,
    },
    options,
  );
};

export const getPostV6LoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6Login>>,
    TError,
    { data: BodyType<UserLoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6Login>>,
  TError,
  { data: BodyType<UserLoginRequest> },
  TContext
> => {
  const mutationKey = ['postV6Login'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6Login>>,
    { data: BodyType<UserLoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV6Login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6LoginMutationResult = NonNullable<Awaited<ReturnType<typeof postV6Login>>>;
export type PostV6LoginMutationBody = BodyType<UserLoginRequest>;
export type PostV6LoginMutationError = ErrorType<unknown>;

/**
 * @summary 로그인 v6
 */
export const usePostV6Login = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6Login>>,
      TError,
      { data: BodyType<UserLoginRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6Login>>,
  TError,
  { data: BodyType<UserLoginRequest> },
  TContext
> => {
  const mutationOptions = getPostV6LoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary randomRecreation
 */
export const postV6RandomRecreation = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<string>(
    { url: `/api/v6/random-recreation`, method: 'POST', signal },
    options,
  );
};

export const getPostV6RandomRecreationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6RandomRecreation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6RandomRecreation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postV6RandomRecreation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6RandomRecreation>>,
    void
  > = () => {
    return postV6RandomRecreation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6RandomRecreationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6RandomRecreation>>
>;

export type PostV6RandomRecreationMutationError = ErrorType<unknown>;

/**
 * @summary randomRecreation
 */
export const usePostV6RandomRecreation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6RandomRecreation>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6RandomRecreation>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostV6RandomRecreationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary twoFactorAuthentication
 */
export const postV6TwoFactorAuthentication = (
  user2FaRequest: MaybeRef<User2FaRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  user2FaRequest = unref(user2FaRequest);

  return customAxiosInstance<UserLoginV6Response>(
    {
      url: `/api/v6/twoFactorAuthentication`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: user2FaRequest,
      signal,
    },
    options,
  );
};

export const getPostV6TwoFactorAuthenticationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>,
    TError,
    { data: BodyType<User2FaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>,
  TError,
  { data: BodyType<User2FaRequest> },
  TContext
> => {
  const mutationKey = ['postV6TwoFactorAuthentication'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>,
    { data: BodyType<User2FaRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV6TwoFactorAuthentication(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV6TwoFactorAuthenticationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>
>;
export type PostV6TwoFactorAuthenticationMutationBody = BodyType<User2FaRequest>;
export type PostV6TwoFactorAuthenticationMutationError = ErrorType<unknown>;

/**
 * @summary twoFactorAuthentication
 */
export const usePostV6TwoFactorAuthentication = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>,
      TError,
      { data: BodyType<User2FaRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV6TwoFactorAuthentication>>,
  TError,
  { data: BodyType<User2FaRequest> },
  TContext
> => {
  const mutationOptions = getPostV6TwoFactorAuthenticationMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 사용자 정보 수정
 */
export const patchV6UsersLock = (
  params: MaybeRef<PatchV6UsersLockParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  params = unref(params);

  return customAxiosInstance<UserV6Response>(
    { url: `/api/v6/users/lock`, method: 'PATCH', params: unref(params) },
    options,
  );
};

export const getPatchV6UsersLockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV6UsersLock>>,
    TError,
    { params: PatchV6UsersLockParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV6UsersLock>>,
  TError,
  { params: PatchV6UsersLockParams },
  TContext
> => {
  const mutationKey = ['patchV6UsersLock'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV6UsersLock>>,
    { params: PatchV6UsersLockParams }
  > = (props) => {
    const { params } = props ?? {};

    return patchV6UsersLock(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV6UsersLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV6UsersLock>>
>;

export type PatchV6UsersLockMutationError = ErrorType<unknown>;

/**
 * @summary 사용자 정보 수정
 */
export const usePatchV6UsersLock = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV6UsersLock>>,
      TError,
      { params: PatchV6UsersLockParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV6UsersLock>>,
  TError,
  { params: PatchV6UsersLockParams },
  TContext
> => {
  const mutationOptions = getPatchV6UsersLockMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
